import { ContributorProfile } from "./ContributorProfile";
import { UnknownOrNoContributions } from "./UnknownOrNoContributions";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ContributionHistoryError(_ref) {
  let {
    address,
    ensName
  } = _ref;
  return /*#__PURE__*/_jsxs("main", {
    children: [/*#__PURE__*/_jsx(ContributorProfile, {
      address: address,
      ensName: ensName
    }), /*#__PURE__*/_jsx(UnknownOrNoContributions, {
      address: address,
      ensName: ensName
    })]
  });
}